import SimpleBar, { type Props as SimpleBarProps } from 'simplebar-react';

export type ScrollbarProps = SimpleBarProps;

export const Scrollbar = (props: ScrollbarProps) => <SimpleBar {...props} />;
